import React, { useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import { DialogContent} from '@mui/material';
import MonitoringList from '../MonitoringList';



function PopMonitoring (props) {
    
    const [chosenMonitoring, setChosenMonitoring] = useState(props.inductionMonitoring);
    
    function handleClick() {
        props.close();
            }

    function handleSend() {
        props.chosenMonitoring(chosenMonitoring);
        
        props.close();

    }

    function addMonitoring(monitoring, index) {

        const newChosenMonitoring = chosenMonitoring
        newChosenMonitoring.splice(index, 1, monitoring)
        setChosenMonitoring(newChosenMonitoring)
    }

    return (
    <Dialog
            open={props.open}
            maxWidth="lg"
        >
            <DialogTitle>{props.titre}</DialogTitle>
            <DialogContent dividers>
                <div>
                    <FormControl >
                        <FormGroup >
                            <FormLabel>Monitoring</FormLabel>
                            {chosenMonitoring.map((monitoring, index) => {

                                return (
                                    <MonitoringList
                                        key={index}
                                        monitoring={monitoring}
                                        index={index}
                                        send={addMonitoring}
                                    />
                                )
                            })}

                        </FormGroup>
                    </FormControl>
                
                </div>
            </DialogContent>
            <DialogActions>
                <Button color="primary" onClick={handleClick}>
                    Cancel
                    </Button>
                <Button color="primary" onClick={handleSend}>
                    OK
                    </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PopMonitoring;